var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayout',[_c('PageTitle',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_c('Breadcrumbs'),_c('Users',{staticClass:"mt-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }